import { checkPermission } from "../utils/ViewPermissions";
export default (app)=>{
  app.directive("permission", checkPermission);
}